/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { ApiError } from './ApiError'
import { ApiErrorFromJSON, ApiErrorFromJSONTyped, ApiErrorToJSON } from './ApiError'
import type { ServiceLocationSeoFieldsAdmin } from './ServiceLocationSeoFieldsAdmin'
import {
  ServiceLocationSeoFieldsAdminFromJSON,
  ServiceLocationSeoFieldsAdminFromJSONTyped,
  ServiceLocationSeoFieldsAdminToJSON,
} from './ServiceLocationSeoFieldsAdmin'

/**
 *
 * @export
 * @interface EnvelopedServiceLocationSeoFieldsServiceLocationSeoFieldsAdmin
 */
export interface EnvelopedServiceLocationSeoFieldsServiceLocationSeoFieldsAdmin {
  /**
   *
   * @type {ServiceLocationSeoFieldsAdmin}
   * @memberof EnvelopedServiceLocationSeoFieldsServiceLocationSeoFieldsAdmin
   */
  body: ServiceLocationSeoFieldsAdmin
  /**
   *
   * @type {Array<ApiError>}
   * @memberof EnvelopedServiceLocationSeoFieldsServiceLocationSeoFieldsAdmin
   */
  errors: Array<ApiError>
}

/**
 * Check if a given object implements the EnvelopedServiceLocationSeoFieldsServiceLocationSeoFieldsAdmin interface.
 */
export function instanceOfEnvelopedServiceLocationSeoFieldsServiceLocationSeoFieldsAdmin(
  value: object,
): boolean {
  let isInstance = true
  isInstance = isInstance && 'body' in value
  isInstance = isInstance && 'errors' in value

  return isInstance
}

export function EnvelopedServiceLocationSeoFieldsServiceLocationSeoFieldsAdminFromJSON(
  json: any,
): EnvelopedServiceLocationSeoFieldsServiceLocationSeoFieldsAdmin {
  return EnvelopedServiceLocationSeoFieldsServiceLocationSeoFieldsAdminFromJSONTyped(json, false)
}

export function EnvelopedServiceLocationSeoFieldsServiceLocationSeoFieldsAdminFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EnvelopedServiceLocationSeoFieldsServiceLocationSeoFieldsAdmin {
  if (json === undefined || json === null) {
    return json
  }
  return {
    body: ServiceLocationSeoFieldsAdminFromJSON(json['body']),
    errors: (json['errors'] as Array<any>).map(ApiErrorFromJSON),
  }
}

export function EnvelopedServiceLocationSeoFieldsServiceLocationSeoFieldsAdminToJSON(
  value?: EnvelopedServiceLocationSeoFieldsServiceLocationSeoFieldsAdmin | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    body: ServiceLocationSeoFieldsAdminToJSON(value.body),
    errors: (value.errors as Array<any>).map(ApiErrorToJSON),
  }
}
